import { render, staticRenderFns } from "./Speeddea.vue?vue&type=template&id=3b423a78&scoped=true"
import script from "./Speeddea.vue?vue&type=script&lang=js"
export * from "./Speeddea.vue?vue&type=script&lang=js"
import style0 from "./Speeddea.vue?vue&type=style&index=0&id=3b423a78&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b423a78",
  null
  
)

export default component.exports